import ColumnTypes from '@/utils/ColumnTypes';
const drDetails = {
	key: 'drDetails',
	label: '联系信息',
	type: () => import('./components/tableCell/contactDetails'),
	fixed: 'left',
	minWidth: '250',
};

const add_time = {
	key: 'add_time',
	label: '添加时间',
	type: 'rdText',
	minWidth: '180',
};
const anchor_info = {
	key: 'anchor_info',
	label: '关联达人',
	type: () => import('./components/tableCell/contactDr'),
	minWidth: '250',
};
const source_type_desc = {
	key: 'source_type_desc',
	label: '来源',
	type: 'rdText',
	minWidth: '150',
};
const is_bind = {
	key: 'is_bind',
	label: '绑定微信',
	type: () => import('./components/tableCell/bindWx'),
	minWidth: '120',
};
const is_add_wx = {
	key: 'is_add_wx',
	label: '是否添加微信',
	type: () => import('./components/tableCell/addWx'),
	minWidth: '160',
	auth: 'system:talnetContacts:add-edit',
};
const remark = {
	key: 'remark',
	label: '备注',
	type: 'rdText',
	minWidth: '180',
	ellipsisRow: 2,
};

const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	minWidth: '120',
	fixed: 'right',
	align: 'right',
};

export const columns = [drDetails, add_time, anchor_info, source_type_desc, is_bind, is_add_wx, remark, operations];
